export interface BodySegment {
  text: string;
  href: string | null;
}

// Trailing punctuation is sentence syntax, not part of the address; a closing bracket only belongs
// to the link when the link opened one.
function trimTrailing(url: string): string {
  let end = url.length;
  while (end > 0) {
    const char = url[end - 1];
    if ('.,;:!?"\''.includes(char)) end -= 1;
    else if (char === ')' && (url.slice(0, end).match(/\(/g)?.length ?? 0) <= (url.slice(0, end).match(/\)/g)?.length ?? 0) - 1)
      end -= 1;
    else break;
  }

  return url.slice(0, end);
}

/**
 * Splits an event body into plain and linked runs. Only absolute http(s) addresses become links —
 * anything else stays text, so a body can never smuggle a `javascript:` target into an anchor.
 */
export function linkifyBody(body: string): BodySegment[] {
  const segments: BodySegment[] = [];
  const pattern = /https?:\/\/[^\s<>"']+/g;
  let cursor = 0;

  for (let match = pattern.exec(body); match; match = pattern.exec(body)) {
    const href = trimTrailing(match[0]);
    if (!href) continue;
    if (match.index > cursor) segments.push({ text: body.slice(cursor, match.index), href: null });
    segments.push({ text: href, href });
    cursor = match.index + href.length;
  }

  if (cursor < body.length) segments.push({ text: body.slice(cursor), href: null });
  return segments;
}
